import { TaskAssignee } from './TaskAssignee';
import { TaskStatus } from './TaskStatus';
import { User } from './User';
import { Workspace } from './Workspace';

export enum TaskPriority {
    URGENT = 'Urgent',
    HIGH = 'High',
    MEDIUM = 'Medium',
    LOW = 'Low',
}

export enum TaskVisibility {
    PRIVATE = 'Private',
    SHARED = 'Shared',
    WORKSPACE = 'Workspace',
}

export enum TaskType {
    DRAFT = 'Draft',
    TEMPLATE = 'Template',
}

export interface Task {
    id: string;
    workspace: Workspace;
    user: User;
    title: string;
    description: string;
    dueAt: Date | null | undefined;
    dueReminderSentAt: Date | null | undefined;
    overdueReminderSentAt: Date | null | undefined;
    completed: boolean;
    status: TaskStatus | null | undefined;
    assignees: TaskAssignee[];
    associations: Record<string, unknown>[] | undefined;
    priority: TaskPriority | null | undefined;
    visibility: TaskVisibility | undefined;
    type: TaskType | null | undefined;
    createdAt: Date;
    updatedAt: Date;
}
